import * as React from "react";
import { useState, useEffect } from "react";
import jfetch from "../../utils/jfetch";

function VirtualEvents(props){

  useEffect(() => {
    jfetch.get('/virtual_events/index.json').then((res) => {
      setEvents(res.virtual_events)
      setDate(res.meta.date)
    })
  }, [])

  const [events, setEvents] = useState([])
  const [date, setDate] = useState('')
  return (
    <div className="row" style={{paddingTop:'30px'}}>
      <div className="col-lg-10 col-lg-offset-1" style={{backgroundColor:'#3D4853'}}>
        <div>
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 style={{color:'white', fontSize:'33px'}}>Virtual Events <small>{date}</small> ⏰</h2>
            </div>
          </div>
          {events.map((event) => {
            const img_url = event.event_ended ? 'https://chartec-core-images.s3.us-west-1.amazonaws.com/checked.png' : 'https://chartec-core-images.s3.us-west-1.amazonaws.com/unchecked.png'
            return (
              <div className="row" key={event.id} style={{color:'white'}}>
                <div className="col-lg-12" style={{paddingTop:'20px', paddingBottom:'20px', borderTop:'1px solid white', fontSize:'18px'}}>
                  <img 
                    src={img_url }
                    height="22px"
                    style={{marginRight:'15px'}}
                  />
                  {event.is_live && (
                    <a href="/live/1" style={{display:'inline-block', backgroundColor:'white', color:'#D0021C', padding:'5px 9px', marginRight:'10px'}}>
                      LIVE NOW!
                    </a>
                  )}
                  {event.start_time} - {event.end_time}. <strong>{event.title}</strong> - {event.presenter}
                  {event.is_live && (
                    <a href="/live/1" className="btn btn-danger" style={{marginLeft:'10px'}}>
                      View Event
                    </a>
                  )}                  
                </div>
              </div>
            )
          })}                    
        </div>
      </div>
    </div>
  )
}

export default VirtualEvents


// WEBPACK FOOTER //
// ./app/javascript/components/home/VirtualEvents.tsx